import { selectAuthState } from "@/redux/features/authentication";
import { useSelector } from "react-redux";
import { useMemo } from "react";

const useAuth = () => {
  const user = useSelector(selectAuthState.authUser);
  // console.log("useAuth - user from state:", user);

  return useMemo(() => user || null, [user]);
};

export default useAuth;
